import { render } from "./SalaryGuidePage.vue?vue&type=template&id=71ceefb6"
import script from "./SalaryGuidePage.vue?vue&type=script&lang=js"
export * from "./SalaryGuidePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__